// Shim for react-native-share on web
// Uses Web Share API when available, falls back to clipboard

// Simple toast notification for web
const showToast = (message) => {
  const toast = document.createElement('div');
  toast.textContent = message;
  toast.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #323232;
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    z-index: 10000;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    animation: slideUp 0.3s ease-out;
  `;
  
  // Add animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideUp {
      from { transform: translate(-50%, 100px); opacity: 0; }
      to { transform: translate(-50%, 0); opacity: 1; }
    }
  `;
  document.head.appendChild(style);
  
  document.body.appendChild(toast);
  
  setTimeout(() => {
    toast.style.animation = 'slideUp 0.3s ease-out reverse';
    setTimeout(() => {
      document.body.removeChild(toast);
      document.head.removeChild(style);
    }, 300);
  }, 2000);
};

const Share = {
  open: async (options) => {
    try {
      const { message, url, title } = options || {};
      const textToShare = message || url || '';
      
      // Try to use Web Share API if available
      if (navigator.share) {
        try {
          await navigator.share({
            title: title || 'Share',
            text: textToShare,
            url: url,
          });
          console.log('✅ Shared successfully using Web Share API');
          return { success: true };
        } catch (shareError) {
          // User cancelled or share failed, fall through to clipboard
          if (shareError.name !== 'AbortError') {
            console.log('Web Share API failed, falling back to clipboard:', shareError.message);
          } else {
            return { success: false, message: 'User cancelled share' };
          }
        }
      }
      
      // Fallback: Copy to clipboard
      if (navigator.clipboard && textToShare) {
        await navigator.clipboard.writeText(textToShare);
        console.log('✅ Copied to clipboard:', textToShare);
        showToast('Link copied to clipboard!');
        return { success: true };
      }
      
      console.warn('Share and clipboard APIs not available on this browser');
      return { success: false };
    } catch (error) {
      console.error('Error in share shim:', error);
      return { success: false, error: error.message };
    }
  },
};

export default Share;
